import React from 'react';
import { CASE_STATUSES } from '../constants/supportCases';
import './StatusStepper.css';

/**
 * Horizontal chevron progress bar for a case's status pipeline.
 *  - editable=false (end users): display-only; shows where the case sits.
 *  - editable=true (case-workers): each stage is clickable to set the status,
 *    plus a "Mark stage complete" button that advances to the next stage.
 */
function StatusStepper({ status, editable = false, onChange, disabled = false }) {
  const currentIndex = Math.max(0, CASE_STATUSES.findIndex((s) => s.value === status));
  const next = CASE_STATUSES[currentIndex + 1];

  const setStatus = (value) => {
    if (!editable || disabled || !onChange) return;
    if (value !== status) onChange(value);
  };

  return (
    <div className={`status-stepper${editable ? ' editable' : ''}`}>
      <div className="status-stepper-track" role="list" aria-label="Case status">
        {CASE_STATUSES.map((s, i) => {
          const state = i < currentIndex ? 'done' : i === currentIndex ? 'current' : 'upcoming';
          return (
            <button
              type="button"
              key={s.value}
              role="listitem"
              className={`status-stepper-seg ${state}`}
              disabled={!editable || disabled}
              onClick={() => setStatus(s.value)}
              aria-current={i === currentIndex ? 'step' : undefined}
              title={editable ? `Set status: ${s.label}` : s.label}
            >
              {s.label}
            </button>
          );
        })}
      </div>
      {editable && next && (
        <button
          type="button"
          className="status-stepper-complete"
          onClick={() => setStatus(next.value)}
          disabled={disabled}
          title={`Advance to “${next.label}”`}
        >
          <span aria-hidden>✓</span> Mark stage complete
        </button>
      )}
    </div>
  );
}

export default StatusStepper;
